/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareLookupItem } from './MatrixCareLookupItem';
import {
    MatrixCareLookupItemFromJSON,
    MatrixCareLookupItemFromJSONTyped,
    MatrixCareLookupItemToJSON,
    MatrixCareLookupItemToJSONTyped,
} from './MatrixCareLookupItem';
import type { MatrixCareDocumentTypeItem } from './MatrixCareDocumentTypeItem';
import {
    MatrixCareDocumentTypeItemFromJSON,
    MatrixCareDocumentTypeItemFromJSONTyped,
    MatrixCareDocumentTypeItemToJSON,
    MatrixCareDocumentTypeItemToJSONTyped,
} from './MatrixCareDocumentTypeItem';

/**
 * 
 * @export
 * @interface MatrixCareHomeHealthLookupsResponse
 */
export interface MatrixCareHomeHealthLookupsResponse {
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    business_units: Array<MatrixCareLookupItem>;
    /**
     * Present only when `business_unit_id` query param was supplied.
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    lines_of_business?: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    races: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    ethnicities: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    genders: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    marital_statuses: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    lives_alone_options: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    sexual_orientations: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    gender_identities: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    religions: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    facility_discharge_types: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareLookupItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    referral_sources: Array<MatrixCareLookupItem>;
    /**
     * 
     * @type {Array<MatrixCareDocumentTypeItem>}
     * @memberof MatrixCareHomeHealthLookupsResponse
     */
    document_types: Array<MatrixCareDocumentTypeItem>;
}

/**
 * Check if a given object implements the MatrixCareHomeHealthLookupsResponse interface.
 */
export function instanceOfMatrixCareHomeHealthLookupsResponse(value: object): value is MatrixCareHomeHealthLookupsResponse {
    if (!('business_units' in value) || value['business_units'] === undefined) return false;
    if (!('races' in value) || value['races'] === undefined) return false;
    if (!('ethnicities' in value) || value['ethnicities'] === undefined) return false;
    if (!('genders' in value) || value['genders'] === undefined) return false;
    if (!('marital_statuses' in value) || value['marital_statuses'] === undefined) return false;
    if (!('lives_alone_options' in value) || value['lives_alone_options'] === undefined) return false;
    if (!('sexual_orientations' in value) || value['sexual_orientations'] === undefined) return false;
    if (!('gender_identities' in value) || value['gender_identities'] === undefined) return false;
    if (!('religions' in value) || value['religions'] === undefined) return false;
    if (!('facility_discharge_types' in value) || value['facility_discharge_types'] === undefined) return false;
    if (!('referral_sources' in value) || value['referral_sources'] === undefined) return false;
    if (!('document_types' in value) || value['document_types'] === undefined) return false;
    return true;
}

export function MatrixCareHomeHealthLookupsResponseFromJSON(json: any): MatrixCareHomeHealthLookupsResponse {
    return MatrixCareHomeHealthLookupsResponseFromJSONTyped(json, false);
}

export function MatrixCareHomeHealthLookupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareHomeHealthLookupsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'business_units': ((json['business_units'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'lines_of_business': json['lines_of_business'] == null ? undefined : ((json['lines_of_business'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'races': ((json['races'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'ethnicities': ((json['ethnicities'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'genders': ((json['genders'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'marital_statuses': ((json['marital_statuses'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'lives_alone_options': ((json['lives_alone_options'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'sexual_orientations': ((json['sexual_orientations'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'gender_identities': ((json['gender_identities'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'religions': ((json['religions'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'facility_discharge_types': ((json['facility_discharge_types'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'referral_sources': ((json['referral_sources'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
        'document_types': ((json['document_types'] as Array<any>).map(MatrixCareDocumentTypeItemFromJSON)),
    };
}

export function MatrixCareHomeHealthLookupsResponseToJSON(json: any): MatrixCareHomeHealthLookupsResponse {
    return MatrixCareHomeHealthLookupsResponseToJSONTyped(json, false);
}

export function MatrixCareHomeHealthLookupsResponseToJSONTyped(value?: MatrixCareHomeHealthLookupsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'business_units': ((value['business_units'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'lines_of_business': value['lines_of_business'] == null ? undefined : ((value['lines_of_business'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'races': ((value['races'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'ethnicities': ((value['ethnicities'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'genders': ((value['genders'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'marital_statuses': ((value['marital_statuses'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'lives_alone_options': ((value['lives_alone_options'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'sexual_orientations': ((value['sexual_orientations'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'gender_identities': ((value['gender_identities'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'religions': ((value['religions'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'facility_discharge_types': ((value['facility_discharge_types'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'referral_sources': ((value['referral_sources'] as Array<any>).map(MatrixCareLookupItemToJSON)),
        'document_types': ((value['document_types'] as Array<any>).map(MatrixCareDocumentTypeItemToJSON)),
    };
}

